import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=baa17f44&scoped=true"
import script from "./remarkDialog.vue?vue&type=script&lang=js"
export * from "./remarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa17f44",
  null
  
)

export default component.exports